import { useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'

export function useInviteFlow(): {
  inviteToken: string | null
  pendingAutoAccept: boolean
  setPendingAutoAccept: Dispatch<SetStateAction<boolean>>
  clearInviteToken: () => void
} {
  const [inviteToken,       setInviteToken]       = useState<string | null>(
    () => new URLSearchParams(window.location.search).get('token')
  )
  const [pendingAutoAccept, setPendingAutoAccept] = useState(false)

  function clearInviteToken() {
    setInviteToken(null)
    setPendingAutoAccept(false)
    window.history.replaceState({}, '', '/')
  }

  return { inviteToken, pendingAutoAccept, setPendingAutoAccept, clearInviteToken }
}
